import type { UniversityRepository } from "@src/domain/universities/repository/university_repository";
import type { UniversityDTO, CreateUniversityInputDTO } from "../dto/university.dto";
import { University } from "@src/domain/universities/entities/university.entity";

/**
 * Use Case: Create University
 */
export class CreateUniversityUseCase {
    constructor(private readonly universityRepository: UniversityRepository) { }

    async execute(data: CreateUniversityInputDTO): Promise<UniversityDTO> {
        this.validateCreateData(data);

        const university = University.create({
            name: data.name,
            code: data.code,
            description: data.description,
            address: data.address,
            website: data.website,
            isActive: true,
            createdAt: new Date(),
            updatedAt: new Date(),
        });

        await this.universityRepository.create(university);

        return {
            university_id: university.universityId,
            name: university.name,
            code: university.code,
            description: university.description,
            address: university.address,
            website: university.website,
            is_active: university.isActive,
            created_at: university.createdAt.toISOString(),
            updated_at: university.updatedAt.toISOString(),
        };
    }

    private validateCreateData(data: CreateUniversityInputDTO): void {
        if (!data.name || !data.name.trim()) {
            throw new Error('University name is required');
        }

        if (!data.code || !data.code.trim()) {
            throw new Error('University code is required');
        }
    }
}